import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of, tap, throwError } from 'rxjs';
import { config } from 'src/app/config/api.config';
import { PaginatedResponse } from 'src/app/interfaces/paginateResponse.interface';
import { Admis } from 'src/app/model/Admis';
import { Activity } from 'src/app/model/Avtivity';
import { LogsDeliberation } from 'src/app/model/LogsDeliberation';
import { NewParcourCertificate } from 'src/app/model/NewParcourCertificate';
import { NewTestQualification } from 'src/app/model/NewTestQualification.model';
import { Certificate } from 'src/app/model/apprenantFode.model';
import { Certificat } from 'src/app/model/certificat';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { UnifiedCertificateDTO } from 'src/app/model/dto/UnifiedCertificateDTO';
import { DeliberationDto } from 'src/app/model/dto/deliberationDto';
import { Family } from 'src/app/model/family';
import { HorsParcourCertificate } from 'src/app/model/hors-parcours-certificate.model';
import { TestQualification } from 'src/app/model/testQualification.model';

@Injectable({
  providedIn: 'root',
})
export class AppelsService {
  constructor(private http: HttpClient) { }

  private buildPaginationParams(
    page: number = 0,
    size: number = 10,
  ): HttpParams {
    return new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
  }

  public getListSoumissions(email: string): Observable<any> {
    //// //console.log(config.apiBaseUrl);
    return this.http.get(
      `${config.apiBaseUrl}/apprenent/studentCourses/${email}`,
    );
  }
  public getAllCohortesParcoursImproved(): Observable<any> {
    return this.http.get<any[]>(`${config.apiBaseUrl}/cohorteParcours/all`);
  }
  getListApplicationsOffTrack(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/applicationOffTrack/listApplicationOffTrack/${cohorte}`,
    );
  }
  getInfoSiguibycohorte(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/application/cohorte/${cohorte}`,
    );
  }
  getInfoHorsSiguibycohorte(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/applicationOffTrack/cohorte/${cohorte}`,
    );
  }
  getInfobycohorte(base: string, cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/${base}/cohorte/${cohorte}`,
    );
  }

  getAllApplicationOffTrackPaged(
    page: number = 0,
    size: number = 0,
  ): Observable<PaginatedResponse<any>> {
    const params = this.buildPaginationParams(page, size);
    return this.http.get<PaginatedResponse<any>>(
      `${config.apiBaseUrl}/applicationOffTrack/all/paged`,
      { params },
    );
  }

  getAllApplicationWebinaireSimplifyPaginated(
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<any>> {
    const params = this.buildPaginationParams(page, size);
    return this.http.get<PaginatedResponse<any>>(
      `${config.apiBaseUrl}/applicationWebinaire/all/paginated`,
      { params },
    );
  }

  //get list certificate
  getCertificateListFromMoodle(): Observable<Certificat[]> {
    return this.http.get<any[]>(
      `${config.apiBaseUrl}/certificate/certificatById`,
    );
  }
  getCertificateListFromFODE(): Observable<Certificat[]> {
    return this.http.get<any[]>(
      `${config.apiBaseUrl}/certificate/certificateList`,
    );
  }

  getCertificateListFromMoodlePaged(
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<Certificat>> {
    const params = this.buildPaginationParams(page, size);
    return this.http.get<PaginatedResponse<Certificat>>(
      `${config.apiBaseUrl}/certificate/certificatById/paged`,
      { params },
    );
  }

  getCertificateListFromFODEPaged(
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<Certificat>> {
    const params = this.buildPaginationParams(page, size);
    return this.http.get<PaginatedResponse<Certificat>>(
      `${config.apiBaseUrl}/certificate/certificateList/paged`,
      { params },
    );
  }

  getSiguiCertificateFromFODE(): Observable<CustomResponse> {
    // console.log(
    //   'Appel API - Début: Récupération des certificats hors parcours'
    // );
    return this.http.get<CustomResponse>(
      `${config.apiBaseUrl}/certificats/All`,
    );
  }

  getHorsParcoursSiguiCertificateFromFODE(): Observable<CustomResponse> {
    return this.http.get<CustomResponse>(
      `${config.apiBaseUrl}/hpCertificats/all`,
    );
  }

  getSiguiCertificateFromFODEPaged(
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<CustomResponse>> {
    const params = this.buildPaginationParams(page, size);
    return this.http.get<PaginatedResponse<CustomResponse>>(
      `${config.apiBaseUrl}/certificats/All/paged`,
      { params },
    );
  }

  getHorsParcoursSiguiCertificateFromFODEPaged(
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<CustomResponse>> {
    const params = this.buildPaginationParams(page, size);
    return this.http.get<PaginatedResponse<CustomResponse>>(
      `${config.apiBaseUrl}/hpCertificats/all/paged`,
      { params },
    );
  }

  getWebinairesPaged(
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<any>> {
    const params = this.buildPaginationParams(page, size);
    return this.http.get<PaginatedResponse<any>>(
      `${config.apiBaseUrl}/webinaireSimplify/sorted-by-date`,
      { params },
    );
  }

  getMentoratCertificatesPaged(
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<CustomResponse>> {
    const params = this.buildPaginationParams(page, size);
    return this.http.get<PaginatedResponse<CustomResponse>>(
      `${config.apiBaseUrl}/certificats/mentorat/paged`,
      { params },
    );
  }

  getAllCertificatesPaged(
    page: number = 0,
    size: number = 10,
    sortBy: string = 'fullname',
    sortDirection: string = 'asc',
  ): Observable<PaginatedResponse<UnifiedCertificateDTO>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PaginatedResponse<UnifiedCertificateDTO>>(
      `${config.apiBaseUrl}/certificats/combined/paged`,
      { params },
    );
  }

  // Service creation d'Activités

  public createAvtivity(activity: Activity): Observable<CustomResponse> {
    /*  const headers = new HttpHeaders({
      Authorization:
        'bearer ' +
        'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJNYUN4dGt5emV0blRzcWYxQlZkM1pOQXZENXNvX1JidzJSVV9yalJfbHVnIn0.eyJleHAiOjE3MDkyOTg3MjksImlhdCI6MTcwOTI5ODQyOSwianRpIjoiNzJmOWQyYmYtOWE0YS00N2JjLTg4ZWItNjkyNTRiZDFhYzE4IiwiaXNzIjoiaHR0cHM6Ly9yYWFnbmFsZS5mb3JjZS1uLnNuL3JlYWxtcy9GT0RFX0tleWNsYW9rIiwiYXVkIjoiYWNjb3VudCIsInN1YiI6IjlkODJhZjE0LTkwMTQtNGU0Ny04MmU3LWI0YmVjYzQ2YThkOCIsInR5cCI6IkJlYXJlciIsImF6cCI6ImZrX2NsaWVudCIsInNlc3Npb25fc3RhdGUiOiI2N2RkZjAyYy01YTFlLTRlYTQtYWQ5ZS05MTEzOTU3ZDcwMTUiLCJhY3IiOiIxIiwiYWxsb3dlZC1vcmlnaW5zIjpbIioiXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbImRlZmF1bHQtcm9sZXMtZm9kZV9rZXljbGFvayIsIm9mZmxpbmVfYWNjZXNzIiwidW1hX2F1dGhvcml6YXRpb24iXX0sInJlc291cmNlX2FjY2VzcyI6eyJhY2NvdW50Ijp7InJvbGVzIjpbIm1hbmFnZS1hY2NvdW50IiwibWFuYWdlLWFjY291bnQtbGlua3MiLCJ2aWV3LXByb2ZpbGUiXX19LCJzY29wZSI6ImVtYWlsIHByb2ZpbGUiLCJzaWQiOiI2N2RkZjAyYy01YTFlLTRlYTQtYWQ5ZS05MTEzOTU3ZDcwMTUiLCJ1cG4iOiJ0ZXN0amVhbkB1bmNoay5lZHUuc24iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmFtZSI6IkRJQVRUQSBKZWFuIiwicHJlZmVycmVkX3VzZXJuYW1lIjoidGVzdGplYW5AdW5jaGsuZWR1LnNuIiwiZ2l2ZW5fbmFtZSI6IkRJQVRUQSIsImZhbWlseV9uYW1lIjoiSmVhbiIsImVtYWlsIjoidGVzdGplYW5AdW5jaGsuZWR1LnNuIn0.jlpU-MQEecfi1wV-m1OieRY-fUSUp8Skn4Sk3aGsi4ZjDk2bfox4EtkW-jiteHn7vxKUeY4N8Uk8DEMahColLQsVRK2GVS5Vz1G89L0r0Lfc5Dy60ddnl_YktotZwfxVvEf3ksXJZpbId51lFb-6Xh6ADIRXpwj-CUOjS3NNsRu3fxbaCZ72zwYkfHDL_gBWYbTv5WykUGt0tl-E60bRXQ1qCyoSAbpXeMZa5omG8HM6RR4O8SLlrM3XjXDj1qBMlNO0tsDVz8vApQ7raI2si47w0UHZy2XQELDa-ELYJEgEVI4X2R8RFhTKmuoHwvO6-Glx5vnvm_-jn2Ilgd8RkA'
    }); */
    return this.http.post<CustomResponse>(
      `${config.apiBaseUrl}/activity/saveActivity`,
      activity,
    );
  }

  getDefaultParam(): Observable<Family[]> {
    return this.http.get<Family[]>(
      `${config.apiBaseUrl}/deliberation/defaultParam`,
    );
  }

  executeDeliberation(logsDeliberation: LogsDeliberation): Observable<any> {
    return this.http.post<any>(
      `${config.apiBaseUrl}/deliberation/execute-deliberation?load=true`,
      logsDeliberation,
    );
  }

  notifierAdmission(): Observable<CustomResponse> {
    return this.http.get<CustomResponse>(
      `${config.apiBaseUrl}/deliberation/notifier`,
    );
  }
  notifierNonAdmission(): Observable<CustomResponse> {
    return this.http.get<CustomResponse>(
      `${config.apiBaseUrl}/deliberation/notifier/non-admis`,
    );
  }

  public getListAdmis(cohorte: string): Observable<Admis[]> {
    return this.http.get<Admis[]>(
      `${config.apiBaseUrl}/deliberation/list-of-admis?cohorte=${encodeURIComponent(cohorte)}`,
    );
    /*.pipe(
        tap((response) => this.log(response)),
        catchError((error) => this.handleError(error, null)),
      );*/
  }
  public getListNoAdmis(): Observable<Admis[]> {
    return this.http.get<Admis[]>(
      `${config.apiBaseUrl}/deliberation/list-non-admis`,
    );
    /*.pipe(
        tap((response) => this.log(response)),
        catchError((error) => this.handleError(error, null)),
      );*/
  }
  public getAdmisBySexe(): Observable<Admis[]> {
    return this.http.get<Admis[]>(`${config.apiBaseUrl}/deliberation/admis`);
  }

  public getNoAdmisBySexe(): Observable<Admis[]> {
    return this.http.get<Admis[]>(`${config.apiBaseUrl}/deliberation/noadmis`);
  }

  exportToPDF(): Observable<Blob> {
    return this.http.get(
      `${config.apiBaseUrl}/deliberation/print-admis-to-pdf`,
      { responseType: 'blob' },
    );
  }

  public checkAdmission(iuf: String, cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.openBaseUrl}/opencontroller/confirmation/` +
      `${iuf}` +
      `/` +
      `${cohorte}`,
    );
  }

  exportAdmisExcel(): Observable<Blob> {
    return this.http.get(
      `${config.apiBaseUrl}/deliberation/print-admis-to-excel`,
      { responseType: 'blob' },
    );
  }

  getDistinctIsFromByCohorte(cohorte: string): Observable<string[]> {
    return this.http.get<string[]>(
      `${config.apiBaseUrl
      }/deliberation/distinct-isFrom?cohorte=${encodeURIComponent(cohorte)}`,
    );
  }

  exportHorsSiguiExcelAdmis(
    cohorte: string,
    isFrom?: string | null,
  ): Observable<Blob> {
    let params = new HttpParams();
    params = params.set('cohorte', cohorte);
    if (isFrom) {
      params = params.set('isFrom', isFrom);
    }
    return this.http.get(
      `${config.apiBaseUrl}/deliberation/print-admisHS-to-excel`,
      {
        params: params,
        responseType: 'blob',
      },
    );
  }

  exportAdmisPDFHorsSigui(): Observable<Blob> {
    return this.http.get(`${config.apiBaseUrl}/deliberation/export-to-pdf-hs`, {
      responseType: 'blob',
    });
  }

  exportToPDFNonAdmis(): Observable<Blob> {
    return this.http.get(
      `${config.apiBaseUrl}/deliberation/print-non-admis-to-pdf`,
      { responseType: 'blob' },
    );
  }

  exportAdmisExcelNonAdmis(): Observable<Blob> {
    return this.http.get(
      `${config.apiBaseUrl}/deliberation/print-non-admis-to-excel`,
      { responseType: 'blob' },
    );
  }

  getTestStats(): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/testQualification/statistics`,
    );
  }

  getAllTestQualification(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/testQualification/${cohorte}`,
    );
  }
  getBeneficiaryByIuf(Email: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/beneficiary/beneficiary2/${Email}`,
    );
  }
  updateCertificat(id: number, data: any): Observable<any> {
    return this.http.put(
      `${config.apiBaseUrl}/newParcourCertificate/${id}`,
      data,
    );
  }
  updateCertificatHp(externalId: number, data: any): Observable<any> {
    return this.http.put(
      `${config.apiBaseUrl}/hpCertificats/${externalId}`,
      data,
    );
  }

  updateWebinar(id: number, webinarDto: any): Observable<any> {
    return this.http.put(
      `${config.apiBaseUrl}/webinaireSimplify/` + id,
      webinarDto,
    );
  }

  createNewCertificate(formData: FormData): Observable<CustomResponse> {
    return this.http.post<any>(
      `${config.apiBaseUrl}/certificats/createCertificate`,
      formData,
    );
  }

  createNewCertificateImprove(formData: FormData): Observable<CustomResponse> {
    return this.http.post<any>(
      `${config.apiBaseUrl}/certificats/createCertificateImprove`,
      formData,
    );
  }

  getAllCohortesParcours(): Observable<any[]> {
    return this.http.get<any[]>(`${config.apiBaseUrl}/cohorteParcours/all`);
  }

  getCohortesByName(cohorteName: string): Observable<string> {
    return this.http.get<string>(
      `${config.apiBaseUrl}/cohortes/name/${cohorteName}`,
    );
  }

  getCertificateById(id: number): Observable<any> {
    // Replace the URL with your actual API endpoint
    return this.http.get<any>(`/api/certificates/${id}`);
  }
  ///////
  diagramGender(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countByGender?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  searchCertificates(
    keyword: string,
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<Certificat>> {
    const params = new HttpParams()
      .set('keyword', keyword)
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PaginatedResponse<Certificat>>(
      `${config.apiBaseUrl}/certificate/search`,
      { params },
    );
  }

  diagramNationality(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countByNationality?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  diagramStatus(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countByStatus?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  diagramLevel(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countLevel?cohorte=${encodeURIComponent(cohorte)}`,
    );
  }

  diagramRightStatus(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countRightStatus?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  diagramRightDiplom(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countHightDiplom?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  diagramSerieBac(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countBacSerie?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  diagramSerieBTS(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countDisciBTS_?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  diagramLicenceMaster(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countDisciLicenceMaster?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  diagramRegion(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countRegion?cohorte=${encodeURIComponent(cohorte)}`,
    );
  }

  diagramHandicap(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countHandicap?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  diagramRightHandicap(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countRightHandicap?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  diagramFamilly(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countFamly?cohorte=${encodeURIComponent(cohorte)}`,
    );
  }

  diagramDisponiblity(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/countDisponible?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  diagramForncenKnow(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/forcenKnow?cohorte=${encodeURIComponent(cohorte)}`,
    );
  }

  diagramForncenCertified(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/forcenCertified?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  diagramProjetIssu(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/projetIssu?cohorte=${encodeURIComponent(cohorte)}`,
    );
  }

  allStaticsDiagrams(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl
      }/newCandidatueJotform/allStatics?cohorte=${encodeURIComponent(cohorte)}`,
    );
  }

  allCohorte(): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/newCandidatueJotform/getCohorte`,
    );
  }

  allCohorteHP(): Observable<any> {
    return this.http.get<any>(`${config.apiBaseUrl}/admisStat/getCohorte`);
  }

  addTestToCertificate(test: NewTestQualification): Observable<CustomResponse> {
    return this.http.post<CustomResponse>(
      `${config.apiBaseUrl}/newtestqualification/addImprove`,
      test,
    );
  }
  getTestByCertificateId(id: number): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/newtestqualification/certificate/${id}`,
    );
  }

  deleteTestById(id: number): Observable<CustomResponse> {
    return this.http.delete<CustomResponse>(
      `${config.apiBaseUrl}/newtestqualification/delete/${id}`,
    );
  }
  updateTest(
    updatedTest: NewTestQualification,
    id: number,
  ): Observable<CustomResponse> {
    return this.http.put<CustomResponse>(
      `${config.apiBaseUrl}/newtestqualification/update/${id}`,
      updatedTest,
    );
  }

  recupTestStats(cohorte: string): Observable<any> {
    return this.http
      .get<any>(
        `${config.apiBaseUrl}/newtestqualification/recupTest/${cohorte}`,
      )
      .pipe(
        tap((response) => this.log(response)),
        catchError((error) => this.handleError(error, null)),
      );
  }

  listCategory(): Observable<any> {
    return this.http.get<any>(`${config.apiBaseUrl}/certificatCategory/all`);
  }

  public enrollMultiple(file: FormData, id: number): Observable<any> {
    return this.http.post<any>(
      `${config.apiBaseUrl}/certificats/multiEnrolment/${id}`,
      file,
    );
  }

  createHorsParcoursCertificate(
    horsParcoursDTO: HorsParcourCertificate,
  ): Observable<CustomResponse> {
    return this.http.post<any>(
      `${config.apiBaseUrl}/certificats/independent-certificate`,
      horsParcoursDTO,
    );
  }
  getAllCertificatCodes(): Observable<any[]> {
    return this.http.get<any[]>(
      `${config.apiBaseUrl}/certificats/certificate-codes`,
    );
  }
  getCertificateForDuplication(externalId: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/certificats/independent-certificate/${externalId}/duplicate`,
    );
  }
  public offTracksConfirm(
    iuf: String,
    cohorte: string,
  ): Observable<CustomResponse> {
    return this.http.get<CustomResponse>(
      `${config.openBaseUrl}/opencontroller/off-tracks/confirmation/` +
      `${iuf}` +
      `/${cohorte}`,
    );
  }

  //Hors Parcours endpoints of stats
  allStaticsDiagramsForHP(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/admisStat/allStatics?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  private log(response: any) {
    console.table(response);
  }

  private handleError(error: Error, errorValue: any) {
    console.error(error);
    return of(errorValue);
  }

  getFamiliesWithCohortes(): Observable<any[]> {
    return this.http.get<any[]>(`${config.apiBaseUrl}/famillemetiers/grouped`);
  }
  getOffTractWithCohortes(): Observable<any[]> {
    return this.http.get<any[]>(
      `${config.apiBaseUrl}/applicationOffTrack/grouped-by-category`,
    );
  }

  getCourseraCohortes(): Observable<string[]> {
    return this.http.get<string[]>(
      `${config.apiBaseUrl}/coursera/stats/cohortes`,
    );
    return this.http.get<any[]>(
      `${config.apiBaseUrl}/applicationOffTrack/grouped-by-category`,
    );
  }
  allStaticsDiagramsForHP2(cohorte: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/admisStat/allStaticsHP?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  getOffTractBeninWithCohortes(iuf: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${config.apiBaseUrl}/foreignManager/${iuf}/family-metiers`,
    );
  }

  getHorsParcoursSiguiCertificateBenin(
    page: number = 0,
    size: number = 10,
    iuf: string
  ): Observable<PaginatedResponse<CustomResponse>> {
    const params = this.buildPaginationParams(page, size);
    return this.http.get<PaginatedResponse<CustomResponse>>(
      `${config.apiBaseUrl}/hpCertificats/partner/${iuf}/paged`,
      { params },
    );
  }
  getApplicationOffTrackByPartnerPaged(
    iuf: string,
    page: number = 0,
    size: number = 10
  ): Observable<PaginatedResponse<any>> {
    const params = this.buildPaginationParams(page, size);
    return this.http.get<PaginatedResponse<any>>(
      `${config.apiBaseUrl}/foreignManager/${iuf}/applicationList`,
      { params }
    );
  }

  searchWebinaires(
    keyword: string,
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<any>> {
    const params = new HttpParams()
      .set('keyword', keyword)
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PaginatedResponse<any>>(
      `${config.apiBaseUrl}/webinaireSimplify/search`,
      { params },
    );
  }


}
